var map = {
	"./0B.png": [
		"./src/assets/aerolineas/0B.png",
		"src_assets_aerolineas_0B_png"
	],
	"./1AC.gif": [
		"./src/assets/aerolineas/1AC.gif",
		"src_assets_aerolineas_1AC_gif"
	],
	"./1AC.jpg": [
		"./src/assets/aerolineas/1AC.jpg",
		"src_assets_aerolineas_1AC_jpg"
	],
	"./1AE.gif": [
		"./src/assets/aerolineas/1AE.gif",
		"src_assets_aerolineas_1AE_gif"
	],
	"./1AE.jpg": [
		"./src/assets/aerolineas/1AE.jpg",
		"src_assets_aerolineas_1AE_jpg"
	],
	"./1AI.jpg": [
		"./src/assets/aerolineas/1AI.jpg",
		"src_assets_aerolineas_1AI_jpg"
	],
	"./1AV.jpg": [
		"./src/assets/aerolineas/1AV.jpg",
		"src_assets_aerolineas_1AV_jpg"
	],
	"./1BC.jpg": [
		"./src/assets/aerolineas/1BC.jpg",
		"src_assets_aerolineas_1BC_jpg"
	],
	"./1BQ.jpg": [
		"./src/assets/aerolineas/1BQ.jpg",
		"src_assets_aerolineas_1BQ_jpg"
	],
	"./1CH.jpg": [
		"./src/assets/aerolineas/1CH.jpg",
		"src_assets_aerolineas_1CH_jpg"
	],
	"./1DE.jpg": [
		"./src/assets/aerolineas/1DE.jpg",
		"src_assets_aerolineas_1DE_jpg"
	],
	"./1NA.png": [
		"./src/assets/aerolineas/1NA.png",
		"src_assets_aerolineas_1NA_png"
	],
	"./1PR.png": [
		"./src/assets/aerolineas/1PR.png",
		"src_assets_aerolineas_1PR_png"
	],
	"./1X.jpg": [
		"./src/assets/aerolineas/1X.jpg",
		"src_assets_aerolineas_1X_jpg"
	],
	"./2D.jpg": [
		"./src/assets/aerolineas/2D.jpg",
		"src_assets_aerolineas_2D_jpg"
	],
	"./2I.jpg": [
		"./src/assets/aerolineas/2I.jpg",
		"src_assets_aerolineas_2I_jpg"
	],
	"./2J.jpg": [
		"./src/assets/aerolineas/2J.jpg",
		"src_assets_aerolineas_2J_jpg"
	],
	"./2K.jpg": [
		"./src/assets/aerolineas/2K.jpg",
		"src_assets_aerolineas_2K_jpg"
	],
	"./2L.jpg": [
		"./src/assets/aerolineas/2L.jpg",
		"src_assets_aerolineas_2L_jpg"
	],
	"./2M.jpg": [
		"./src/assets/aerolineas/2M.jpg",
		"src_assets_aerolineas_2M_jpg"
	],
	"./2W.jpg": [
		"./src/assets/aerolineas/2W.jpg",
		"src_assets_aerolineas_2W_jpg"
	],
	"./2Z.png": [
		"./src/assets/aerolineas/2Z.png",
		"src_assets_aerolineas_2Z_png"
	],
	"./3E.png": [
		"./src/assets/aerolineas/3E.png",
		"src_assets_aerolineas_3E_png"
	],
	"./3J.jpg": [
		"./src/assets/aerolineas/3J.jpg",
		"src_assets_aerolineas_3J_jpg"
	],
	"./3K.png": [
		"./src/assets/aerolineas/3K.png",
		"src_assets_aerolineas_3K_png"
	],
	"./3M.png": [
		"./src/assets/aerolineas/3M.png",
		"src_assets_aerolineas_3M_png"
	],
	"./3P.png": [
		"./src/assets/aerolineas/3P.png",
		"src_assets_aerolineas_3P_png"
	],
	"./3R.jpg": [
		"./src/assets/aerolineas/3R.jpg",
		"src_assets_aerolineas_3R_jpg"
	],
	"./3S.png": [
		"./src/assets/aerolineas/3S.png",
		"src_assets_aerolineas_3S_png"
	],
	"./4C.png": [
		"./src/assets/aerolineas/4C.png",
		"src_assets_aerolineas_4C_png"
	],
	"./4M.png": [
		"./src/assets/aerolineas/4M.png",
		"src_assets_aerolineas_4M_png"
	],
	"./4O.png": [
		"./src/assets/aerolineas/4O.png",
		"src_assets_aerolineas_4O_png"
	],
	"./5H.png": [
		"./src/assets/aerolineas/5H.png",
		"src_assets_aerolineas_5H_png"
	],
	"./5L.png": [
		"./src/assets/aerolineas/5L.png",
		"src_assets_aerolineas_5L_png"
	],
	"./5Q.png": [
		"./src/assets/aerolineas/5Q.png",
		"src_assets_aerolineas_5Q_png"
	],
	"./5U.png": [
		"./src/assets/aerolineas/5U.png",
		"src_assets_aerolineas_5U_png"
	],
	"./6C.png": [
		"./src/assets/aerolineas/6C.png",
		"src_assets_aerolineas_6C_png"
	],
	"./7C.png": [
		"./src/assets/aerolineas/7C.png",
		"src_assets_aerolineas_7C_png"
	],
	"./7E.png": [
		"./src/assets/aerolineas/7E.png",
		"src_assets_aerolineas_7E_png"
	],
	"./7I.png": [
		"./src/assets/aerolineas/7I.png",
		"src_assets_aerolineas_7I_png"
	],
	"./7P.png": [
		"./src/assets/aerolineas/7P.png",
		"src_assets_aerolineas_7P_png"
	],
	"./7Y.png": [
		"./src/assets/aerolineas/7Y.png",
		"src_assets_aerolineas_7Y_png"
	],
	"./8I.png": [
		"./src/assets/aerolineas/8I.png",
		"src_assets_aerolineas_8I_png"
	],
	"./8N.png": [
		"./src/assets/aerolineas/8N.png",
		"src_assets_aerolineas_8N_png"
	],
	"./8P.png": [
		"./src/assets/aerolineas/8P.png",
		"src_assets_aerolineas_8P_png"
	],
	"./8R.png": [
		"./src/assets/aerolineas/8R.png",
		"src_assets_aerolineas_8R_png"
	],
	"./9B.png": [
		"./src/assets/aerolineas/9B.png",
		"src_assets_aerolineas_9B_png"
	],
	"./9N.png": [
		"./src/assets/aerolineas/9N.png",
		"src_assets_aerolineas_9N_png"
	],
	"./9R.png": [
		"./src/assets/aerolineas/9R.png",
		"src_assets_aerolineas_9R_png"
	],
	"./9V.png": [
		"./src/assets/aerolineas/9V.png",
		"src_assets_aerolineas_9V_png"
	],
	"./9Y.png": [
		"./src/assets/aerolineas/9Y.png",
		"src_assets_aerolineas_9Y_png"
	],
	"./A0.png": [
		"./src/assets/aerolineas/A0.png",
		"src_assets_aerolineas_A0_png"
	],
	"./A4.png": [
		"./src/assets/aerolineas/A4.png",
		"src_assets_aerolineas_A4_png"
	],
	"./A7.png": [
		"./src/assets/aerolineas/A7.png",
		"src_assets_aerolineas_A7_png"
	],
	"./A8.png": [
		"./src/assets/aerolineas/A8.png",
		"src_assets_aerolineas_A8_png"
	],
	"./AA.png": [
		"./src/assets/aerolineas/AA.png",
		"src_assets_aerolineas_AA_png"
	],
	"./AB.png": [
		"./src/assets/aerolineas/AB.png",
		"src_assets_aerolineas_AB_png"
	],
	"./AC.png": [
		"./src/assets/aerolineas/AC.png",
		"src_assets_aerolineas_AC_png"
	],
	"./AD.jpg": [
		"./src/assets/aerolineas/AD.jpg",
		"src_assets_aerolineas_AD_jpg"
	],
	"./AD.png": [
		"./src/assets/aerolineas/AD.png",
		"src_assets_aerolineas_AD_png"
	],
	"./AF.png": [
		"./src/assets/aerolineas/AF.png",
		"src_assets_aerolineas_AF_png"
	],
	"./AI.png": [
		"./src/assets/aerolineas/AI.png",
		"src_assets_aerolineas_AI_png"
	],
	"./AM.png": [
		"./src/assets/aerolineas/AM.png",
		"src_assets_aerolineas_AM_png"
	],
	"./AO.png": [
		"./src/assets/aerolineas/AO.png",
		"src_assets_aerolineas_AO_png"
	],
	"./AR.png": [
		"./src/assets/aerolineas/AR.png",
		"src_assets_aerolineas_AR_png"
	],
	"./AS.png": [
		"./src/assets/aerolineas/AS.png",
		"src_assets_aerolineas_AS_png"
	],
	"./AT.png": [
		"./src/assets/aerolineas/AT.png",
		"src_assets_aerolineas_AT_png"
	],
	"./AT_bckup.png": [
		"./src/assets/aerolineas/AT_bckup.png",
		"src_assets_aerolineas_AT_bckup_png"
	],
	"./AU.png": [
		"./src/assets/aerolineas/AU.png",
		"src_assets_aerolineas_AU_png"
	],
	"./AV.png": [
		"./src/assets/aerolineas/AV.png",
		"src_assets_aerolineas_AV_png"
	],
	"./AW.png": [
		"./src/assets/aerolineas/AW.png",
		"src_assets_aerolineas_AW_png"
	],
	"./AY.png": [
		"./src/assets/aerolineas/AY.png",
		"src_assets_aerolineas_AY_png"
	],
	"./AZ.png": [
		"./src/assets/aerolineas/AZ.png",
		"src_assets_aerolineas_AZ_png"
	],
	"./B0.png": [
		"./src/assets/aerolineas/B0.png",
		"src_assets_aerolineas_B0_png"
	],
	"./B2.png": [
		"./src/assets/aerolineas/B2.png",
		"src_assets_aerolineas_B2_png"
	],
	"./B4.png": [
		"./src/assets/aerolineas/B4.png",
		"src_assets_aerolineas_B4_png"
	],
	"./B5.png": [
		"./src/assets/aerolineas/B5.png",
		"src_assets_aerolineas_B5_png"
	],
	"./B6.png": [
		"./src/assets/aerolineas/B6.png",
		"src_assets_aerolineas_B6_png"
	],
	"./B7.png": [
		"./src/assets/aerolineas/B7.png",
		"src_assets_aerolineas_B7_png"
	],
	"./BA.png": [
		"./src/assets/aerolineas/BA.png",
		"src_assets_aerolineas_BA_png"
	],
	"./BB.png": [
		"./src/assets/aerolineas/BB.png",
		"src_assets_aerolineas_BB_png"
	],
	"./BD.png": [
		"./src/assets/aerolineas/BD.png",
		"src_assets_aerolineas_BD_png"
	],
	"./BE.png": [
		"./src/assets/aerolineas/BE.png",
		"src_assets_aerolineas_BE_png"
	],
	"./BG.png": [
		"./src/assets/aerolineas/BG.png",
		"src_assets_aerolineas_BG_png"
	],
	"./BI.png": [
		"./src/assets/aerolineas/BI.png",
		"src_assets_aerolineas_BI_png"
	],
	"./BJ.png": [
		"./src/assets/aerolineas/BJ.png",
		"src_assets_aerolineas_BJ_png"
	],
	"./BL.png": [
		"./src/assets/aerolineas/BL.png",
		"src_assets_aerolineas_BL_png"
	],
	"./BP.png": [
		"./src/assets/aerolineas/BP.png",
		"src_assets_aerolineas_BP_png"
	],
	"./BR.png": [
		"./src/assets/aerolineas/BR.png",
		"src_assets_aerolineas_BR_png"
	],
	"./BT.png": [
		"./src/assets/aerolineas/BT.png",
		"src_assets_aerolineas_BT_png"
	],
	"./BV.png": [
		"./src/assets/aerolineas/BV.png",
		"src_assets_aerolineas_BV_png"
	],
	"./BW.png": [
		"./src/assets/aerolineas/BW.png",
		"src_assets_aerolineas_BW_png"
	],
	"./BZ.png": [
		"./src/assets/aerolineas/BZ.png",
		"src_assets_aerolineas_BZ_png"
	],
	"./C8.png": [
		"./src/assets/aerolineas/C8.png",
		"src_assets_aerolineas_C8_png"
	],
	"./CA.png": [
		"./src/assets/aerolineas/CA.png",
		"src_assets_aerolineas_CA_png"
	],
	"./CC.png": [
		"./src/assets/aerolineas/CC.png",
		"src_assets_aerolineas_CC_png"
	],
	"./CG.png": [
		"./src/assets/aerolineas/CG.png",
		"src_assets_aerolineas_CG_png"
	],
	"./CI.png": [
		"./src/assets/aerolineas/CI.png",
		"src_assets_aerolineas_CI_png"
	],
	"./CL.png": [
		"./src/assets/aerolineas/CL.png",
		"src_assets_aerolineas_CL_png"
	],
	"./CM.png": [
		"./src/assets/aerolineas/CM.png",
		"src_assets_aerolineas_CM_png"
	],
	"./CO.png": [
		"./src/assets/aerolineas/CO.png",
		"src_assets_aerolineas_CO_png"
	],
	"./CQ.png": [
		"./src/assets/aerolineas/CQ.png",
		"src_assets_aerolineas_CQ_png"
	],
	"./CU - Cubana de Aviacion.png": [
		"./src/assets/aerolineas/CU - Cubana de Aviacion.png",
		"src_assets_aerolineas_CU_-_Cubana_de_Aviacion_png"
	],
	"./CU.png": [
		"./src/assets/aerolineas/CU.png",
		"src_assets_aerolineas_CU_png"
	],
	"./CX - Cathay Pacific.png": [
		"./src/assets/aerolineas/CX - Cathay Pacific.png",
		"src_assets_aerolineas_CX_-_Cathay_Pacific_png"
	],
	"./CX.png": [
		"./src/assets/aerolineas/CX.png",
		"src_assets_aerolineas_CX_png"
	],
	"./CY.png": [
		"./src/assets/aerolineas/CY.png",
		"src_assets_aerolineas_CY_png"
	],
	"./CZ.png": [
		"./src/assets/aerolineas/CZ.png",
		"src_assets_aerolineas_CZ_png"
	],
	"./D2.png": [
		"./src/assets/aerolineas/D2.png",
		"src_assets_aerolineas_D2_png"
	],
	"./D8.png": [
		"./src/assets/aerolineas/D8.png",
		"src_assets_aerolineas_D8_png"
	],
	"./DD.png": [
		"./src/assets/aerolineas/DD.png",
		"src_assets_aerolineas_DD_png"
	],
	"./DE.png": [
		"./src/assets/aerolineas/DE.png",
		"src_assets_aerolineas_DE_png"
	],
	"./DI.png": [
		"./src/assets/aerolineas/DI.png",
		"src_assets_aerolineas_DI_png"
	],
	"./DL.png": [
		"./src/assets/aerolineas/DL.png",
		"src_assets_aerolineas_DL_png"
	],
	"./DN.png": [
		"./src/assets/aerolineas/DN.png",
		"src_assets_aerolineas_DN_png"
	],
	"./DP.png": [
		"./src/assets/aerolineas/DP.png",
		"src_assets_aerolineas_DP_png"
	],
	"./DR.png": [
		"./src/assets/aerolineas/DR.png",
		"src_assets_aerolineas_DR_png"
	],
	"./DV.png": [
		"./src/assets/aerolineas/DV.png",
		"src_assets_aerolineas_DV_png"
	],
	"./DY.png": [
		"./src/assets/aerolineas/DY.png",
		"src_assets_aerolineas_DY_png"
	],
	"./DZ.png": [
		"./src/assets/aerolineas/DZ.png",
		"src_assets_aerolineas_DZ_png"
	],
	"./E3 - EGO Airways.jpeg": [
		"./src/assets/aerolineas/E3 - EGO Airways.jpeg",
		"src_assets_aerolineas_E3_-_EGO_Airways_jpeg"
	],
	"./E3.png": [
		"./src/assets/aerolineas/E3.png",
		"src_assets_aerolineas_E3_png"
	],
	"./E7.png": [
		"./src/assets/aerolineas/E7.png",
		"src_assets_aerolineas_E7_png"
	],
	"./E8.png": [
		"./src/assets/aerolineas/E8.png",
		"src_assets_aerolineas_E8_png"
	],
	"./E9.png": [
		"./src/assets/aerolineas/E9.png",
		"src_assets_aerolineas_E9_png"
	],
	"./EF.png": [
		"./src/assets/aerolineas/EF.png",
		"src_assets_aerolineas_EF_png"
	],
	"./EG.png": [
		"./src/assets/aerolineas/EG.png",
		"src_assets_aerolineas_EG_png"
	],
	"./EI - Aer Lingus.png": [
		"./src/assets/aerolineas/EI - Aer Lingus.png",
		"src_assets_aerolineas_EI_-_Aer_Lingus_png"
	],
	"./EI.png": [
		"./src/assets/aerolineas/EI.png",
		"src_assets_aerolineas_EI_png"
	],
	"./EK - Emirates.png": [
		"./src/assets/aerolineas/EK - Emirates.png",
		"src_assets_aerolineas_EK_-_Emirates_png"
	],
	"./EK.png": [
		"./src/assets/aerolineas/EK.png",
		"src_assets_aerolineas_EK_png"
	],
	"./EL - Ellinair.png": [
		"./src/assets/aerolineas/EL - Ellinair.png",
		"src_assets_aerolineas_EL_-_Ellinair_png"
	],
	"./EMT - Emetebe.png": [
		"./src/assets/aerolineas/EMT - Emetebe.png",
		"src_assets_aerolineas_EMT_-_Emetebe_png"
	],
	"./EN - Air Dolomiti.png": [
		"./src/assets/aerolineas/EN - Air Dolomiti.png",
		"src_assets_aerolineas_EN_-_Air_Dolomiti_png"
	],
	"./EQ - TAME.png": [
		"./src/assets/aerolineas/EQ - TAME.png",
		"src_assets_aerolineas_EQ_-_TAME_png"
	],
	"./EQ.png": [
		"./src/assets/aerolineas/EQ.png",
		"src_assets_aerolineas_EQ_png"
	],
	"./ET - Ethiopian Airlines.png": [
		"./src/assets/aerolineas/ET - Ethiopian Airlines.png",
		"src_assets_aerolineas_ET_-_Ethiopian_Airlines_png"
	],
	"./ET.png": [
		"./src/assets/aerolineas/ET.png",
		"src_assets_aerolineas_ET_png"
	],
	"./EY - Etihad Airways.png": [
		"./src/assets/aerolineas/EY - Etihad Airways.png",
		"src_assets_aerolineas_EY_-_Etihad_Airways_png"
	],
	"./EY.png": [
		"./src/assets/aerolineas/EY.png",
		"src_assets_aerolineas_EY_png"
	],
	"./Emirates.png": [
		"./src/assets/aerolineas/Emirates.png",
		"src_assets_aerolineas_Emirates_png"
	],
	"./F2.png": [
		"./src/assets/aerolineas/F2.png",
		"src_assets_aerolineas_F2_png"
	],
	"./F8.png": [
		"./src/assets/aerolineas/F8.png",
		"src_assets_aerolineas_F8_png"
	],
	"./F9.png": [
		"./src/assets/aerolineas/F9.png",
		"src_assets_aerolineas_F9_png"
	],
	"./FA - FlySafair.png": [
		"./src/assets/aerolineas/FA - FlySafair.png",
		"src_assets_aerolineas_FA_-_FlySafair_png"
	],
	"./FA.jpg": [
		"./src/assets/aerolineas/FA.jpg",
		"src_assets_aerolineas_FA_jpg"
	],
	"./FB.png": [
		"./src/assets/aerolineas/FB.png",
		"src_assets_aerolineas_FB_png"
	],
	"./FC - Fly Corporate.png": [
		"./src/assets/aerolineas/FC - Fly Corporate.png",
		"src_assets_aerolineas_FC_-_Fly_Corporate_png"
	],
	"./FC - Link Airways.png": [
		"./src/assets/aerolineas/FC - Link Airways.png",
		"src_assets_aerolineas_FC_-_Link_Airways_png"
	],
	"./FC.png": [
		"./src/assets/aerolineas/FC.png",
		"src_assets_aerolineas_FC_png"
	],
	"./FI - Icelandair.png": [
		"./src/assets/aerolineas/FI - Icelandair.png",
		"src_assets_aerolineas_FI_-_Icelandair_png"
	],
	"./FJ - Fiji Airways.png": [
		"./src/assets/aerolineas/FJ - Fiji Airways.png",
		"src_assets_aerolineas_FJ_-_Fiji_Airways_png"
	],
	"./FL - Air Leap.png": [
		"./src/assets/aerolineas/FL - Air Leap.png",
		"src_assets_aerolineas_FL_-_Air_Leap_png"
	],
	"./FM - Shanghai Airlines.png": [
		"./src/assets/aerolineas/FM - Shanghai Airlines.png",
		"src_assets_aerolineas_FM_-_Shanghai_Airlines_png"
	],
	"./FN - fastjet.png": [
		"./src/assets/aerolineas/FN - fastjet.png",
		"src_assets_aerolineas_FN_-_fastjet_png"
	],
	"./FN.png": [
		"./src/assets/aerolineas/FN.png",
		"src_assets_aerolineas_FN_png"
	],
	"./FP.png": [
		"./src/assets/aerolineas/FP.png",
		"src_assets_aerolineas_FP_png"
	],
	"./FZ - Fly Dubai.png": [
		"./src/assets/aerolineas/FZ - Fly Dubai.png",
		"src_assets_aerolineas_FZ_-_Fly_Dubai_png"
	],
	"./FZ.png": [
		"./src/assets/aerolineas/FZ.png",
		"src_assets_aerolineas_FZ_png"
	],
	"./G3 - GOL Linhas Aereas.png": [
		"./src/assets/aerolineas/G3 - GOL Linhas Aereas.png",
		"src_assets_aerolineas_G3_-_GOL_Linhas_Aereas_png"
	],
	"./G3.png": [
		"./src/assets/aerolineas/G3.png",
		"src_assets_aerolineas_G3_png"
	],
	"./GA.png": [
		"./src/assets/aerolineas/GA.png",
		"src_assets_aerolineas_GA_png"
	],
	"./GF - Gulf Air.png": [
		"./src/assets/aerolineas/GF - Gulf Air.png",
		"src_assets_aerolineas_GF_-_Gulf_Air_png"
	],
	"./GF.png": [
		"./src/assets/aerolineas/GF.png",
		"src_assets_aerolineas_GF_png"
	],
	"./GK.png": [
		"./src/assets/aerolineas/GK.png",
		"src_assets_aerolineas_GK_png"
	],
	"./GL.png": [
		"./src/assets/aerolineas/GL.png",
		"src_assets_aerolineas_GL_png"
	],
	"./GM.png": [
		"./src/assets/aerolineas/GM.png",
		"src_assets_aerolineas_GM_png"
	],
	"./GP.png": [
		"./src/assets/aerolineas/GP.png",
		"src_assets_aerolineas_GP_png"
	],
	"./GQ - Sky Express.png": [
		"./src/assets/aerolineas/GQ - Sky Express.png",
		"src_assets_aerolineas_GQ_-_Sky_Express_png"
	],
	"./GQ.png": [
		"./src/assets/aerolineas/GQ.png",
		"src_assets_aerolineas_GQ_png"
	],
	"./GR.png": [
		"./src/assets/aerolineas/GR.png",
		"src_assets_aerolineas_GR_png"
	],
	"./GS.png": [
		"./src/assets/aerolineas/GS.png",
		"src_assets_aerolineas_GS_png"
	],
	"./H2 - Sky Airline.png": [
		"./src/assets/aerolineas/H2 - Sky Airline.png",
		"src_assets_aerolineas_H2_-_Sky_Airline_png"
	],
	"./H2.png": [
		"./src/assets/aerolineas/H2.png",
		"src_assets_aerolineas_H2_png"
	],
	"./H8.png": [
		"./src/assets/aerolineas/H8.png",
		"src_assets_aerolineas_H8_png"
	],
	"./H9.png": [
		"./src/assets/aerolineas/H9.png",
		"src_assets_aerolineas_H9_png"
	],
	"./HA.png": [
		"./src/assets/aerolineas/HA.png",
		"src_assets_aerolineas_HA_png"
	],
	"./HF.png": [
		"./src/assets/aerolineas/HF.png",
		"src_assets_aerolineas_HF_png"
	],
	"./HM - Air Seychelles.png": [
		"./src/assets/aerolineas/HM - Air Seychelles.png",
		"src_assets_aerolineas_HM_-_Air_Seychelles_png"
	],
	"./HM.png": [
		"./src/assets/aerolineas/HM.png",
		"src_assets_aerolineas_HM_png"
	],
	"./HO - Juneyao Airlines.png": [
		"./src/assets/aerolineas/HO - Juneyao Airlines.png",
		"src_assets_aerolineas_HO_-_Juneyao_Airlines_png"
	],
	"./HO.png": [
		"./src/assets/aerolineas/HO.png",
		"src_assets_aerolineas_HO_png"
	],
	"./HR - Air Senegal.png": [
		"./src/assets/aerolineas/HR - Air Senegal.png",
		"src_assets_aerolineas_HR_-_Air_Senegal_png"
	],
	"./HR.png": [
		"./src/assets/aerolineas/HR.png",
		"src_assets_aerolineas_HR_png"
	],
	"./HS.jpg": [
		"./src/assets/aerolineas/HS.jpg",
		"src_assets_aerolineas_HS_jpg"
	],
	"./HU.png": [
		"./src/assets/aerolineas/HU.png",
		"src_assets_aerolineas_HU_png"
	],
	"./HX.png": [
		"./src/assets/aerolineas/HX.png",
		"src_assets_aerolineas_HX_png"
	],
	"./HY.png": [
		"./src/assets/aerolineas/HY.png",
		"src_assets_aerolineas_HY_png"
	],
	"./HZ.png": [
		"./src/assets/aerolineas/HZ.png",
		"src_assets_aerolineas_HZ_png"
	],
	"./I2.png": [
		"./src/assets/aerolineas/I2.png",
		"src_assets_aerolineas_I2_png"
	],
	"./I6.png": [
		"./src/assets/aerolineas/I6.png",
		"src_assets_aerolineas_I6_png"
	],
	"./IB-LEVEL.png": [
		"./src/assets/aerolineas/IB-LEVEL.png",
		"src_assets_aerolineas_IB-LEVEL_png"
	],
	"./IB.png": [
		"./src/assets/aerolineas/IB.png",
		"src_assets_aerolineas_IB_png"
	],
	"./IG - Air Italy.png": [
		"./src/assets/aerolineas/IG - Air Italy.png",
		"src_assets_aerolineas_IG_-_Air_Italy_png"
	],
	"./IG.png": [
		"./src/assets/aerolineas/IG.png",
		"src_assets_aerolineas_IG_png"
	],
	"./IK.png": [
		"./src/assets/aerolineas/IK.png",
		"src_assets_aerolineas_IK_png"
	],
	"./IO.png": [
		"./src/assets/aerolineas/IO.png",
		"src_assets_aerolineas_IO_png"
	],
	"./IR.png": [
		"./src/assets/aerolineas/IR.png",
		"src_assets_aerolineas_IR_png"
	],
	"./IZ.png": [
		"./src/assets/aerolineas/IZ.png",
		"src_assets_aerolineas_IZ_png"
	],
	"./J2.png": [
		"./src/assets/aerolineas/J2.png",
		"src_assets_aerolineas_J2_png"
	],
	"./J3.png": [
		"./src/assets/aerolineas/J3.png",
		"src_assets_aerolineas_J3_png"
	],
	"./J5.jpg": [
		"./src/assets/aerolineas/J5.jpg",
		"src_assets_aerolineas_J5_jpg"
	],
	"./J7.png": [
		"./src/assets/aerolineas/J7.png",
		"src_assets_aerolineas_J7_png"
	],
	"./J9.png": [
		"./src/assets/aerolineas/J9.png",
		"src_assets_aerolineas_J9_png"
	],
	"./JA.png": [
		"./src/assets/aerolineas/JA.png",
		"src_assets_aerolineas_JA_png"
	],
	"./JD.png": [
		"./src/assets/aerolineas/JD.png",
		"src_assets_aerolineas_JD_png"
	],
	"./JJ - LATAM Brazil.png": [
		"./src/assets/aerolineas/JJ - LATAM Brazil.png",
		"src_assets_aerolineas_JJ_-_LATAM_Brazil_png"
	],
	"./JJ.png": [
		"./src/assets/aerolineas/JJ.png",
		"src_assets_aerolineas_JJ_png"
	],
	"./JL - Japan Airlines.png": [
		"./src/assets/aerolineas/JL - Japan Airlines.png",
		"src_assets_aerolineas_JL_-_Japan_Airlines_png"
	],
	"./JL.png": [
		"./src/assets/aerolineas/JL.png",
		"src_assets_aerolineas_JL_png"
	],
	"./JQ - Jetstar Airways.png": [
		"./src/assets/aerolineas/JQ - Jetstar Airways.png",
		"src_assets_aerolineas_JQ_-_Jetstar_Airways_png"
	],
	"./JQ.png": [
		"./src/assets/aerolineas/JQ.png",
		"src_assets_aerolineas_JQ_png"
	],
	"./JS.png": [
		"./src/assets/aerolineas/JS.png",
		"src_assets_aerolineas_JS_png"
	],
	"./JU.png": [
		"./src/assets/aerolineas/JU.png",
		"src_assets_aerolineas_JU_png"
	],
	"./JX.png": [
		"./src/assets/aerolineas/JX.png",
		"src_assets_aerolineas_JX_png"
	],
	"./JY.png": [
		"./src/assets/aerolineas/JY.png",
		"src_assets_aerolineas_JY_png"
	],
	"./K5.png": [
		"./src/assets/aerolineas/K5.png",
		"src_assets_aerolineas_K5_png"
	],
	"./K6.png": [
		"./src/assets/aerolineas/K6.png",
		"src_assets_aerolineas_K6_png"
	],
	"./K7 - Air KBZ.png": [
		"./src/assets/aerolineas/K7 - Air KBZ.png",
		"src_assets_aerolineas_K7_-_Air_KBZ_png"
	],
	"./K7.jpg": [
		"./src/assets/aerolineas/K7.jpg",
		"src_assets_aerolineas_K7_jpg"
	],
	"./KA.png": [
		"./src/assets/aerolineas/KA.png",
		"src_assets_aerolineas_KA_png"
	],
	"./KC.png": [
		"./src/assets/aerolineas/KC.png",
		"src_assets_aerolineas_KC_png"
	],
	"./KE - Korean Air.png": [
		"./src/assets/aerolineas/KE - Korean Air.png",
		"src_assets_aerolineas_KE_-_Korean_Air_png"
	],
	"./KE.png": [
		"./src/assets/aerolineas/KE.png",
		"src_assets_aerolineas_KE_png"
	],
	"./KF.png": [
		"./src/assets/aerolineas/KF.png",
		"src_assets_aerolineas_KF_png"
	],
	"./KK.png": [
		"./src/assets/aerolineas/KK.png",
		"src_assets_aerolineas_KK_png"
	],
	"./KL.png": [
		"./src/assets/aerolineas/KL.png",
		"src_assets_aerolineas_KL_png"
	],
	"./KM.png": [
		"./src/assets/aerolineas/KM.png",
		"src_assets_aerolineas_KM_png"
	],
	"./KP.png": [
		"./src/assets/aerolineas/KP.png",
		"src_assets_aerolineas_KP_png"
	],
	"./KQ - Kenya Airways.png": [
		"./src/assets/aerolineas/KQ - Kenya Airways.png",
		"src_assets_aerolineas_KQ_-_Kenya_Airways_png"
	],
	"./KQ.png": [
		"./src/assets/aerolineas/KQ.png",
		"src_assets_aerolineas_KQ_png"
	],
	"./KR.png": [
		"./src/assets/aerolineas/KR.png",
		"src_assets_aerolineas_KR_png"
	],
	"./KU.png": [
		"./src/assets/aerolineas/KU.png",
		"src_assets_aerolineas_KU_png"
	],
	"./KW.png": [
		"./src/assets/aerolineas/KW.png",
		"src_assets_aerolineas_KW_png"
	],
	"./KX.png": [
		"./src/assets/aerolineas/KX.png",
		"src_assets_aerolineas_KX_png"
	],
	"./LA - LATAM.png": [
		"./src/assets/aerolineas/LA - LATAM.png",
		"src_assets_aerolineas_LA_-_LATAM_png"
	],
	"./LA.png": [
		"./src/assets/aerolineas/LA.png",
		"src_assets_aerolineas_LA_png"
	],
	"./LB.png": [
		"./src/assets/aerolineas/LB.png",
		"src_assets_aerolineas_LB_png"
	],
	"./LC - Skyway.png": [
		"./src/assets/aerolineas/LC - Skyway.png",
		"src_assets_aerolineas_LC_-_Skyway_png"
	],
	"./LC.png": [
		"./src/assets/aerolineas/LC.png",
		"src_assets_aerolineas_LC_png"
	],
	"./LG.png": [
		"./src/assets/aerolineas/LG.png",
		"src_assets_aerolineas_LG_png"
	],
	"./LH.png": [
		"./src/assets/aerolineas/LH.png",
		"src_assets_aerolineas_LH_png"
	],
	"./LI.png": [
		"./src/assets/aerolineas/LI.png",
		"src_assets_aerolineas_LI_png"
	],
	"./LM.png": [
		"./src/assets/aerolineas/LM.png",
		"src_assets_aerolineas_LM_png"
	],
	"./LO.png": [
		"./src/assets/aerolineas/LO.png",
		"src_assets_aerolineas_LO_png"
	],
	"./LP - LATAM Peru.png": [
		"./src/assets/aerolineas/LP - LATAM Peru.png",
		"src_assets_aerolineas_LP_-_LATAM_Peru_png"
	],
	"./LQ.png": [
		"./src/assets/aerolineas/LQ.png",
		"src_assets_aerolineas_LQ_png"
	],
	"./LR - Avianca Costa Rica.png": [
		"./src/assets/aerolineas/LR - Avianca Costa Rica.png",
		"src_assets_aerolineas_LR_-_Avianca_Costa_Rica_png"
	],
	"./LR.png": [
		"./src/assets/aerolineas/LR.png",
		"src_assets_aerolineas_LR_png"
	],
	"./LX.png": [
		"./src/assets/aerolineas/LX.png",
		"src_assets_aerolineas_LX_png"
	],
	"./LY - El Al Israel Airlines.png": [
		"./src/assets/aerolineas/LY - El Al Israel Airlines.png",
		"src_assets_aerolineas_LY_-_El_Al_Israel_Airlines_png"
	],
	"./LY.png": [
		"./src/assets/aerolineas/LY.png",
		"src_assets_aerolineas_LY_png"
	],
	"./M0.png": [
		"./src/assets/aerolineas/M0.png",
		"src_assets_aerolineas_M0_png"
	],
	"./MA.png": [
		"./src/assets/aerolineas/MA.png",
		"src_assets_aerolineas_MA_png"
	],
	"./MD.png": [
		"./src/assets/aerolineas/MD.png",
		"src_assets_aerolineas_MD_png"
	],
	"./ME.png": [
		"./src/assets/aerolineas/ME.png",
		"src_assets_aerolineas_ME_png"
	],
	"./MF.png": [
		"./src/assets/aerolineas/MF.png",
		"src_assets_aerolineas_MF_png"
	],
	"./MH.png": [
		"./src/assets/aerolineas/MH.png",
		"src_assets_aerolineas_MH_png"
	],
	"./MI.png": [
		"./src/assets/aerolineas/MI.png",
		"src_assets_aerolineas_MI_png"
	],
	"./MJ.png": [
		"./src/assets/aerolineas/MJ.png",
		"src_assets_aerolineas_MJ_png"
	],
	"./MK.png": [
		"./src/assets/aerolineas/MK.png",
		"src_assets_aerolineas_MK_png"
	],
	"./MN.png": [
		"./src/assets/aerolineas/MN.png",
		"src_assets_aerolineas_MN_png"
	],
	"./MO.png": [
		"./src/assets/aerolineas/MO.png",
		"src_assets_aerolineas_MO_png"
	],
	"./MR.png": [
		"./src/assets/aerolineas/MR.png",
		"src_assets_aerolineas_MR_png"
	],
	"./MS.png": [
		"./src/assets/aerolineas/MS.png",
		"src_assets_aerolineas_MS_png"
	],
	"./MU.png": [
		"./src/assets/aerolineas/MU.png",
		"src_assets_aerolineas_MU_png"
	],
	"./MX.png": [
		"./src/assets/aerolineas/MX.png",
		"src_assets_aerolineas_MX_png"
	],
	"./N4.jpg": [
		"./src/assets/aerolineas/N4.jpg",
		"src_assets_aerolineas_N4_jpg"
	],
	"./ND.png": [
		"./src/assets/aerolineas/ND.png",
		"src_assets_aerolineas_ND_png"
	],
	"./NF.png": [
		"./src/assets/aerolineas/NF.png",
		"src_assets_aerolineas_NF_png"
	],
	"./NH - All Nippon Airways.png": [
		"./src/assets/aerolineas/NH - All Nippon Airways.png",
		"src_assets_aerolineas_NH_-_All_Nippon_Airways_png"
	],
	"./NH.png": [
		"./src/assets/aerolineas/NH.png",
		"src_assets_aerolineas_NH_png"
	],
	"./NI.png": [
		"./src/assets/aerolineas/NI.png",
		"src_assets_aerolineas_NI_png"
	],
	"./NK.png": [
		"./src/assets/aerolineas/NK.png",
		"src_assets_aerolineas_NK_png"
	],
	"./NM.png": [
		"./src/assets/aerolineas/NM.png",
		"src_assets_aerolineas_NM_png"
	],
	"./NO.png": [
		"./src/assets/aerolineas/NO.png",
		"src_assets_aerolineas_NO_png"
	],
	"./NP.png": [
		"./src/assets/aerolineas/NP.png",
		"src_assets_aerolineas_NP_png"
	],
	"./NT.png": [
		"./src/assets/aerolineas/NT.png",
		"src_assets_aerolineas_NT_png"
	],
	"./NU.png": [
		"./src/assets/aerolineas/NU.png",
		"src_assets_aerolineas_NU_png"
	],
	"./NX.png": [
		"./src/assets/aerolineas/NX.png",
		"src_assets_aerolineas_NX_png"
	],
	"./NZ.png": [
		"./src/assets/aerolineas/NZ.png",
		"src_assets_aerolineas_NZ_png"
	],
	"./O2.png": [
		"./src/assets/aerolineas/O2.png",
		"src_assets_aerolineas_O2_png"
	],
	"./O6 - Avianca Brasil.png": [
		"./src/assets/aerolineas/O6 - Avianca Brasil.png",
		"src_assets_aerolineas_O6_-_Avianca_Brasil_png"
	],
	"./O6.png": [
		"./src/assets/aerolineas/O6.png",
		"src_assets_aerolineas_O6_png"
	],
	"./OA - Olympic Air.png": [
		"./src/assets/aerolineas/OA - Olympic Air.png",
		"src_assets_aerolineas_OA_-_Olympic_Air_png"
	],
	"./OA.png": [
		"./src/assets/aerolineas/OA.png",
		"src_assets_aerolineas_OA_png"
	],
	"./OB - BoA.png": [
		"./src/assets/aerolineas/OB - BoA.png",
		"src_assets_aerolineas_OB_-_BoA_png"
	],
	"./OB.png": [
		"./src/assets/aerolineas/OB.png",
		"src_assets_aerolineas_OB_png"
	],
	"./OJ.png": [
		"./src/assets/aerolineas/OJ.png",
		"src_assets_aerolineas_OJ_png"
	],
	"./OK.png": [
		"./src/assets/aerolineas/OK.png",
		"src_assets_aerolineas_OK_png"
	],
	"./OM.png": [
		"./src/assets/aerolineas/OM.png",
		"src_assets_aerolineas_OM_png"
	],
	"./OR.png": [
		"./src/assets/aerolineas/OR.png",
		"src_assets_aerolineas_OR_png"
	],
	"./OS - Austrian Airlines.png": [
		"./src/assets/aerolineas/OS - Austrian Airlines.png",
		"src_assets_aerolineas_OS_-_Austrian_Airlines_png"
	],
	"./OS.png": [
		"./src/assets/aerolineas/OS.png",
		"src_assets_aerolineas_OS_png"
	],
	"./OU - Croatia Airlines.png": [
		"./src/assets/aerolineas/OU - Croatia Airlines.png",
		"src_assets_aerolineas_OU_-_Croatia_Airlines_png"
	],
	"./OY.png": [
		"./src/assets/aerolineas/OY.png",
		"src_assets_aerolineas_OY_png"
	],
	"./OZ - Asiana Airlines.png": [
		"./src/assets/aerolineas/OZ - Asiana Airlines.png",
		"src_assets_aerolineas_OZ_-_Asiana_Airlines_png"
	],
	"./OZ.png": [
		"./src/assets/aerolineas/OZ.png",
		"src_assets_aerolineas_OZ_png"
	],
	"./P0.png": [
		"./src/assets/aerolineas/P0.png",
		"src_assets_aerolineas_P0_png"
	],
	"./P4.png": [
		"./src/assets/aerolineas/P4.png",
		"src_assets_aerolineas_P4_png"
	],
	"./P5.png": [
		"./src/assets/aerolineas/P5.png",
		"src_assets_aerolineas_P5_png"
	],
	"./P9.png": [
		"./src/assets/aerolineas/P9.png",
		"src_assets_aerolineas_P9_png"
	],
	"./PB.png": [
		"./src/assets/aerolineas/PB.png",
		"src_assets_aerolineas_PB_png"
	],
	"./PD.png": [
		"./src/assets/aerolineas/PD.png",
		"src_assets_aerolineas_PD_png"
	],
	"./PE - People's.png": [
		"./src/assets/aerolineas/PE - People's.png",
		"src_assets_aerolineas_PE_-_People_s_png"
	],
	"./PE.png": [
		"./src/assets/aerolineas/PE.png",
		"src_assets_aerolineas_PE_png"
	],
	"./PG.png": [
		"./src/assets/aerolineas/PG.png",
		"src_assets_aerolineas_PG_png"
	],
	"./PI.png": [
		"./src/assets/aerolineas/PI.png",
		"src_assets_aerolineas_PI_png"
	],
	"./PK.png": [
		"./src/assets/aerolineas/PK.png",
		"src_assets_aerolineas_PK_png"
	],
	"./PR - Philippine Airlines.png": [
		"./src/assets/aerolineas/PR - Philippine Airlines.png",
		"src_assets_aerolineas_PR_-_Philippine_Airlines_png"
	],
	"./PR.png": [
		"./src/assets/aerolineas/PR.png",
		"src_assets_aerolineas_PR_png"
	],
	"./PS - Ukraine International Airlines.jpg": [
		"./src/assets/aerolineas/PS - Ukraine International Airlines.jpg",
		"src_assets_aerolineas_PS_-_Ukraine_International_Airlines_jpg"
	],
	"./PS.png": [
		"./src/assets/aerolineas/PS.png",
		"src_assets_aerolineas_PS_png"
	],
	"./PU - Plus Ultra Lineas Aereas.png": [
		"./src/assets/aerolineas/PU - Plus Ultra Lineas Aereas.png",
		"src_assets_aerolineas_PU_-_Plus_Ultra_Lineas_Aereas_png"
	],
	"./PU.png": [
		"./src/assets/aerolineas/PU.png",
		"src_assets_aerolineas_PU_png"
	],
	"./PX.png": [
		"./src/assets/aerolineas/PX.png",
		"src_assets_aerolineas_PX_png"
	],
	"./PY - Surinam Airways.png": [
		"./src/assets/aerolineas/PY - Surinam Airways.png",
		"src_assets_aerolineas_PY_-_Surinam_Airways_png"
	],
	"./PY.png": [
		"./src/assets/aerolineas/PY.png",
		"src_assets_aerolineas_PY_png"
	],
	"./PZ - LATAM Paraguay.png": [
		"./src/assets/aerolineas/PZ - LATAM Paraguay.png",
		"src_assets_aerolineas_PZ_-_LATAM_Paraguay_png"
	],
	"./PZ.png": [
		"./src/assets/aerolineas/PZ.png",
		"src_assets_aerolineas_PZ_png"
	],
	"./Q4.png": [
		"./src/assets/aerolineas/Q4.png",
		"src_assets_aerolineas_Q4_png"
	],
	"./QC.png": [
		"./src/assets/aerolineas/QC.png",
		"src_assets_aerolineas_QC_png"
	],
	"./QF.png": [
		"./src/assets/aerolineas/QF.png",
		"src_assets_aerolineas_QF_png"
	],
	"./QH.png": [
		"./src/assets/aerolineas/QH.png",
		"src_assets_aerolineas_QH_png"
	],
	"./QR - Qatar Airways 1.png": [
		"./src/assets/aerolineas/QR - Qatar Airways 1.png",
		"src_assets_aerolineas_QR_-_Qatar_Airways_1_png"
	],
	"./QR - Qatar Airways 2.png": [
		"./src/assets/aerolineas/QR - Qatar Airways 2.png",
		"src_assets_aerolineas_QR_-_Qatar_Airways_2_png"
	],
	"./QR.png": [
		"./src/assets/aerolineas/QR.png",
		"src_assets_aerolineas_QR_png"
	],
	"./QS.png": [
		"./src/assets/aerolineas/QS.png",
		"src_assets_aerolineas_QS_png"
	],
	"./R5.jpg": [
		"./src/assets/aerolineas/R5.jpg",
		"src_assets_aerolineas_R5_jpg"
	],
	"./R5.png": [
		"./src/assets/aerolineas/R5.png",
		"src_assets_aerolineas_R5_png"
	],
	"./R7.png": [
		"./src/assets/aerolineas/R7.png",
		"src_assets_aerolineas_R7_png"
	],
	"./RC - Atlantic Airways.gif": [
		"./src/assets/aerolineas/RC - Atlantic Airways.gif",
		"src_assets_aerolineas_RC_-_Atlantic_Airways_gif"
	],
	"./RC.png": [
		"./src/assets/aerolineas/RC.png",
		"src_assets_aerolineas_RC_png"
	],
	"./RG.png": [
		"./src/assets/aerolineas/RG.png",
		"src_assets_aerolineas_RG_png"
	],
	"./RJ.png": [
		"./src/assets/aerolineas/RJ.png",
		"src_assets_aerolineas_RJ_png"
	],
	"./RO.png": [
		"./src/assets/aerolineas/RO.png",
		"src_assets_aerolineas_RO_png"
	],
	"./RQ.png": [
		"./src/assets/aerolineas/RQ.png",
		"src_assets_aerolineas_RQ_png"
	],
	"./S3.png": [
		"./src/assets/aerolineas/S3.png",
		"src_assets_aerolineas_S3_png"
	],
	"./S4 - SATA Internacional Azores Airlines.jpg": [
		"./src/assets/aerolineas/S4 - SATA Internacional Azores Airlines.jpg",
		"src_assets_aerolineas_S4_-_SATA_Internacional_Azores_Airlines_jpg"
	],
	"./S4.png": [
		"./src/assets/aerolineas/S4.png",
		"src_assets_aerolineas_S4_png"
	],
	"./S7.png": [
		"./src/assets/aerolineas/S7.png",
		"src_assets_aerolineas_S7_png"
	],
	"./SA.png": [
		"./src/assets/aerolineas/SA.png",
		"src_assets_aerolineas_SA_png"
	],
	"./SB.png": [
		"./src/assets/aerolineas/SB.png",
		"src_assets_aerolineas_SB_png"
	],
	"./SC.png": [
		"./src/assets/aerolineas/SC.png",
		"src_assets_aerolineas_SC_png"
	],
	"./SE.png": [
		"./src/assets/aerolineas/SE.png",
		"src_assets_aerolineas_SE_png"
	],
	"./SG.png": [
		"./src/assets/aerolineas/SG.png",
		"src_assets_aerolineas_SG_png"
	],
	"./SK.png": [
		"./src/assets/aerolineas/SK.png",
		"src_assets_aerolineas_SK_png"
	],
	"./SL.png": [
		"./src/assets/aerolineas/SL.png",
		"src_assets_aerolineas_SL_png"
	],
	"./SN.png": [
		"./src/assets/aerolineas/SN.png",
		"src_assets_aerolineas_SN_png"
	],
	"./SP.png": [
		"./src/assets/aerolineas/SP.png",
		"src_assets_aerolineas_SP_png"
	],
	"./SQ - Singapore Airlines.png": [
		"./src/assets/aerolineas/SQ - Singapore Airlines.png",
		"src_assets_aerolineas_SQ_-_Singapore_Airlines_png"
	],
	"./SQ.png": [
		"./src/assets/aerolineas/SQ.png",
		"src_assets_aerolineas_SQ_png"
	],
	"./SS - Corsair.png": [
		"./src/assets/aerolineas/SS - Corsair.png",
		"src_assets_aerolineas_SS_-_Corsair_png"
	],
	"./SU.png": [
		"./src/assets/aerolineas/SU.png",
		"src_assets_aerolineas_SU_png"
	],
	"./SV.png": [
		"./src/assets/aerolineas/SV.png",
		"src_assets_aerolineas_SV_png"
	],
	"./SW.png": [
		"./src/assets/aerolineas/SW.png",
		"src_assets_aerolineas_SW_png"
	],
	"./SY.png": [
		"./src/assets/aerolineas/SY.png",
		"src_assets_aerolineas_SY_png"
	],
	"./SZ.png": [
		"./src/assets/aerolineas/SZ.png",
		"src_assets_aerolineas_SZ_png"
	],
	"./T0.png": [
		"./src/assets/aerolineas/T0.png",
		"src_assets_aerolineas_T0_png"
	],
	"./T3.png": [
		"./src/assets/aerolineas/T3.png",
		"src_assets_aerolineas_T3_png"
	],
	"./TA - TACA.png": [
		"./src/assets/aerolineas/TA - TACA.png",
		"src_assets_aerolineas_TA_-_TACA_png"
	],
	"./TA.png": [
		"./src/assets/aerolineas/TA.png",
		"src_assets_aerolineas_TA_png"
	],
	"./TB.png": [
		"./src/assets/aerolineas/TB.png",
		"src_assets_aerolineas_TB_png"
	],
	"./TC.png": [
		"./src/assets/aerolineas/TC.png",
		"src_assets_aerolineas_TC_png"
	],
	"./TF.png": [
		"./src/assets/aerolineas/TF.png",
		"src_assets_aerolineas_TF_png"
	],
	"./TG.png": [
		"./src/assets/aerolineas/TG.png",
		"src_assets_aerolineas_TG_png"
	],
	"./TJ.png": [
		"./src/assets/aerolineas/TJ.png",
		"src_assets_aerolineas_TJ_png"
	],
	"./TK.png": [
		"./src/assets/aerolineas/TK.png",
		"src_assets_aerolineas_TK_png"
	],
	"./TL.png": [
		"./src/assets/aerolineas/TL.png",
		"src_assets_aerolineas_TL_png"
	],
	"./TM.png": [
		"./src/assets/aerolineas/TM.png",
		"src_assets_aerolineas_TM_png"
	],
	"./TN.png": [
		"./src/assets/aerolineas/TN.png",
		"src_assets_aerolineas_TN_png"
	],
	"./TP.png": [
		"./src/assets/aerolineas/TP.png",
		"src_assets_aerolineas_TP_png"
	],
	"./TR.png": [
		"./src/assets/aerolineas/TR.png",
		"src_assets_aerolineas_TR_png"
	],
	"./TV - Tibet Airlines.jpg": [
		"./src/assets/aerolineas/TV - Tibet Airlines.jpg",
		"src_assets_aerolineas_TV_-_Tibet_Airlines_jpg"
	],
	"./TV.png": [
		"./src/assets/aerolineas/TV.png",
		"src_assets_aerolineas_TV_png"
	],
	"./TX.png": [
		"./src/assets/aerolineas/TX.png",
		"src_assets_aerolineas_TX_png"
	],
	"./U2.png": [
		"./src/assets/aerolineas/U2.png",
		"src_assets_aerolineas_U2_png"
	],
	"./U6.png": [
		"./src/assets/aerolineas/U6.png",
		"src_assets_aerolineas_U6_png"
	],
	"./UA.png": [
		"./src/assets/aerolineas/UA.png",
		"src_assets_aerolineas_UA_png"
	],
	"./UK.png": [
		"./src/assets/aerolineas/UK.png",
		"src_assets_aerolineas_UK_png"
	],
	"./UL.png": [
		"./src/assets/aerolineas/UL.png",
		"src_assets_aerolineas_UL_png"
	],
	"./UM.png": [
		"./src/assets/aerolineas/UM.png",
		"src_assets_aerolineas_UM_png"
	],
	"./UO.png": [
		"./src/assets/aerolineas/UO.png",
		"src_assets_aerolineas_UO_png"
	],
	"./UP - Bahamasair.png": [
		"./src/assets/aerolineas/UP - Bahamasair.png",
		"src_assets_aerolineas_UP_-_Bahamasair_png"
	],
	"./UP.png": [
		"./src/assets/aerolineas/UP.png",
		"src_assets_aerolineas_UP_png"
	],
	"./UQ.png": [
		"./src/assets/aerolineas/UQ.png",
		"src_assets_aerolineas_UQ_png"
	],
	"./UR.png": [
		"./src/assets/aerolineas/UR.png",
		"src_assets_aerolineas_UR_png"
	],
	"./US.png": [
		"./src/assets/aerolineas/US.png",
		"src_assets_aerolineas_US_png"
	],
	"./UT.png": [
		"./src/assets/aerolineas/UT.png",
		"src_assets_aerolineas_UT_png"
	],
	"./UU.png": [
		"./src/assets/aerolineas/UU.png",
		"src_assets_aerolineas_UU_png"
	],
	"./UX - Air Europa.png": [
		"./src/assets/aerolineas/UX - Air Europa.png",
		"src_assets_aerolineas_UX_-_Air_Europa_png"
	],
	"./UX.png": [
		"./src/assets/aerolineas/UX.png",
		"src_assets_aerolineas_UX_png"
	],
	"./V0.png": [
		"./src/assets/aerolineas/V0.png",
		"src_assets_aerolineas_V0_png"
	],
	"./V7.png": [
		"./src/assets/aerolineas/V7.png",
		"src_assets_aerolineas_V7_png"
	],
	"./VA.png": [
		"./src/assets/aerolineas/VA.png",
		"src_assets_aerolineas_VA_png"
	],
	"./VG.png": [
		"./src/assets/aerolineas/VG.png",
		"src_assets_aerolineas_VG_png"
	],
	"./VH.png": [
		"./src/assets/aerolineas/VH.png",
		"src_assets_aerolineas_VH_png"
	],
	"./VN.png": [
		"./src/assets/aerolineas/VN.png",
		"src_assets_aerolineas_VN_png"
	],
	"./VO.png": [
		"./src/assets/aerolineas/VO.png",
		"src_assets_aerolineas_VO_png"
	],
	"./VR.png": [
		"./src/assets/aerolineas/VR.png",
		"src_assets_aerolineas_VR_png"
	],
	"./VS - Virgin Atlantic.png": [
		"./src/assets/aerolineas/VS - Virgin Atlantic.png",
		"src_assets_aerolineas_VS_-_Virgin_Atlantic_png"
	],
	"./VS.png": [
		"./src/assets/aerolineas/VS.png",
		"src_assets_aerolineas_VS_png"
	],
	"./VT.png": [
		"./src/assets/aerolineas/VT.png",
		"src_assets_aerolineas_VT_png"
	],
	"./VV - Viva Peru.png": [
		"./src/assets/aerolineas/VV - Viva Peru.png",
		"src_assets_aerolineas_VV_-_Viva_Peru_png"
	],
	"./VV.png": [
		"./src/assets/aerolineas/VV.png",
		"src_assets_aerolineas_VV_png"
	],
	"./VW.png": [
		"./src/assets/aerolineas/VW.png",
		"src_assets_aerolineas_VW_png"
	],
	"./VY.png": [
		"./src/assets/aerolineas/VY.png",
		"src_assets_aerolineas_VY_png"
	],
	"./W4.png": [
		"./src/assets/aerolineas/W4.png",
		"src_assets_aerolineas_W4_png"
	],
	"./WB.png": [
		"./src/assets/aerolineas/WB.png",
		"src_assets_aerolineas_WB_png"
	],
	"./WE.png": [
		"./src/assets/aerolineas/WE.png",
		"src_assets_aerolineas_WE_png"
	],
	"./WG.png": [
		"./src/assets/aerolineas/WG.png",
		"src_assets_aerolineas_WG_png"
	],
	"./WJ.png": [
		"./src/assets/aerolineas/WJ.png",
		"src_assets_aerolineas_WJ_png"
	],
	"./WM.png": [
		"./src/assets/aerolineas/WM.png",
		"src_assets_aerolineas_WM_png"
	],
	"./WS.png": [
		"./src/assets/aerolineas/WS.png",
		"src_assets_aerolineas_WS_png"
	],
	"./WX - CityJet.png": [
		"./src/assets/aerolineas/WX - CityJet.png",
		"src_assets_aerolineas_WX_-_CityJet_png"
	],
	"./WX.png": [
		"./src/assets/aerolineas/WX.png",
		"src_assets_aerolineas_WX_png"
	],
	"./WY.png": [
		"./src/assets/aerolineas/WY.png",
		"src_assets_aerolineas_WY_png"
	],
	"./WZ.png": [
		"./src/assets/aerolineas/WZ.png",
		"src_assets_aerolineas_WZ_png"
	],
	"./XG.png": [
		"./src/assets/aerolineas/XG.png",
		"src_assets_aerolineas_XG_png"
	],
	"./XK.png": [
		"./src/assets/aerolineas/XK.png",
		"src_assets_aerolineas_XK_png"
	],
	"./XL - LATAM Ecuador.png": [
		"./src/assets/aerolineas/XL - LATAM Ecuador.png",
		"src_assets_aerolineas_XL_-_LATAM_Ecuador_png"
	],
	"./XL.png": [
		"./src/assets/aerolineas/XL.png",
		"src_assets_aerolineas_XL_png"
	],
	"./XQ.png": [
		"./src/assets/aerolineas/XQ.png",
		"src_assets_aerolineas_XQ_png"
	],
	"./XW.png": [
		"./src/assets/aerolineas/XW.png",
		"src_assets_aerolineas_XW_png"
	],
	"./XY.png": [
		"./src/assets/aerolineas/XY.png",
		"src_assets_aerolineas_XY_png"
	],
	"./Y7.png": [
		"./src/assets/aerolineas/Y7.png",
		"src_assets_aerolineas_Y7_png"
	],
	"./YC.png": [
		"./src/assets/aerolineas/YC.png",
		"src_assets_aerolineas_YC_png"
	],
	"./YE.png": [
		"./src/assets/aerolineas/YE.png",
		"src_assets_aerolineas_YE_png"
	],
	"./YM.png": [
		"./src/assets/aerolineas/YM.png",
		"src_assets_aerolineas_YM_png"
	],
	"./YO.png": [
		"./src/assets/aerolineas/YO.png",
		"src_assets_aerolineas_YO_png"
	],
	"./YZ.png": [
		"./src/assets/aerolineas/YZ.png",
		"src_assets_aerolineas_YZ_png"
	],
	"./Z7.png": [
		"./src/assets/aerolineas/Z7.png",
		"src_assets_aerolineas_Z7_png"
	],
	"./Z8.png": [
		"./src/assets/aerolineas/Z8.png",
		"src_assets_aerolineas_Z8_png"
	],
	"./ZE.jpg": [
		"./src/assets/aerolineas/ZE.jpg",
		"src_assets_aerolineas_ZE_jpg"
	],
	"./ZH.png": [
		"./src/assets/aerolineas/ZH.png",
		"src_assets_aerolineas_ZH_png"
	],
	"./ZP.png": [
		"./src/assets/aerolineas/ZP.png",
		"src_assets_aerolineas_ZP_png"
	],
	"./logo-header.png": [
		"./src/assets/aerolineas/logo-header.png",
		"src_assets_aerolineas_logo-header_png"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./src/assets/aerolineas lazy recursive ^\\.\\/.*\\..*$";
module.exports = webpackAsyncContext;